/* eslint-disable */
import React, { useCallback, useRef, useState } from 'react';
import { t } from '@web-solutions/module-localization';
import { reviewImg } from './hairstyle';
import styles from './Reviews.module.scss';

/** One before/now testimonial card. Photos fall back to labelled gradient tiles. */
export const ReviewCard: React.FC<{ ns: string; id: string }> = ({ ns, id }) => {
  const before = reviewImg(`${id}-before`);
  const now = reviewImg(`${id}-now`);
  return (
    <figure className={styles.card}>
      <div className={styles.photos}>
        <div className={styles.photo}>
          {before ? <img src={before} alt="" /> : <span className={styles.ph} aria-hidden="true" />}
          <span className={styles.tag}>{t(`${ns}.beforeLabel`)}</span>
        </div>
        <div className={styles.photo}>
          {now ? <img src={now} alt="" /> : <span className={`${styles.ph} ${styles.phNow}`} aria-hidden="true" />}
          <span className={`${styles.tag} ${styles.tagNow}`}>{t(`${ns}.nowLabel`)}</span>
        </div>
      </div>
      <figcaption>
        <div className={styles.name}>{t(`${ns}.items.${id}.name`)}</div>
        <p className={styles.text}>{t(`${ns}.items.${id}.text`)}</p>
      </figcaption>
    </figure>
  );
};

/** Horizontal-scroll strip of testimonial cards, with a dot per card below it.
    The dot for the currently-centered card turns violet as the user scrolls. */
export const Reviews: React.FC<{ ns: string; ids: string[] }> = ({ ns, ids }) => {
  const stripRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);

  const onScroll = useCallback(() => {
    const el = stripRef.current;
    if (!el) return;
    const center = el.scrollLeft + el.clientWidth / 2;
    let best = 0;
    let bestDist = Infinity;
    Array.from(el.children).forEach((c, i) => {
      const child = c as HTMLElement;
      const cc = child.offsetLeft + child.offsetWidth / 2;
      const d = Math.abs(cc - center);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    setActive(best);
  }, []);

  return (
    <>
      <div className={styles.strip} ref={stripRef} onScroll={onScroll}>
        {ids.map((id) => <ReviewCard key={id} ns={ns} id={id} />)}
      </div>
      {ids.length > 1 && (
        <div className={styles.dots}>
          {ids.map((id, i) => (
            <span key={id} className={`${styles.dot} ${i === active ? styles.dotActive : ''}`} />
          ))}
        </div>
      )}
    </>
  );
};

export default Reviews;
